import { Autocomplete, TextField } from "@mui/material";
import debounce from "lodash/debounce";
import { enqueueSnackbar } from "notistack";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { get } from "../../utils/io";

function HubAutoComplete(props) {
  const { onChange, isXealth, ...rest } = props;
  const [loading, setLoading] = useState(false);
  const [hubs, setHubs] = useState([]);
  const [input, setInput] = useState("");
  const [selected, setSelected] = useState();

  const isLocked = Boolean(selected);

  useEffect(() => {
    const getHubs = debounce(async () => {
      setLoading(true);
      const { status, data } = await get(isXealth ? "/xealth/hubs" : "/hubs", {
        offset: 0,
        limit: 10,
        hub_id: input,
      });
      if (status !== 200) {
        enqueueSnackbar("Unable to retrieve hubs", { variant: "error" });
      } else {
        setHubs(data.hubs);
      }
      setLoading(false);
    }, 300);
    getHubs();
    return getHubs.cancel;
  }, [input, isXealth]);

  return (
    <Autocomplete
      loading={loading}
      options={hubs}
      size="small"
      getOptionLabel={(option) => option?.hub_id || ""}
      onInputChange={(_, value) => setInput(value)}
      onChange={(_, value) => {
        setSelected(value);
        onChange(_, value);
        if (!value) {
          setInput("");
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Start typing to search for a hub"
          inputProps={{
            ...params.inputProps,
            readOnly: isLocked,
          }}
        />
      )}
      isOptionEqualToValue={(option, value) =>
        option?.esn === value?.esn || option?.hub_id === value?.hub_id
      }
      clearOnBlur={false}
      {...rest}
    />
  );
}

HubAutoComplete.propTypes = {
  onChange: PropTypes.func.isRequired,
  isXealth: PropTypes.bool,
};

HubAutoComplete.defaultProps = {
  isXealth: false,
};

export default HubAutoComplete;
